<template>
    <span>
        <!-- <v-btn @click="dialog = true" :color="color[mode]">&nbsp;</v-btn> -->

        <v-dialog v-model="dialog" max-width="600px">
            <template v-slot:activator="{ on }">
                <v-btn v-on="on" :color="color[mode]">
                    <slot name="default" v-bind="{ on }">
                        {{ color[mode] }}
                    </slot>
                </v-btn>
            </template>
            <v-card>
                <v-card-title class="headline">Select Color</v-card-title>
                <v-card-text>
                    <v-color-picker v-model="color" :mode="mode" label="" show-swatches
                        swatches-max-height="100"></v-color-picker>
                    <v-switch v-model="isGradient" label="Gradient"></v-switch>
                    <v-row v-if="isGradient">
                        <v-col cols="6">
                            <v-color-picker v-model="gradientStart" :mode="mode" label="Start Color" show-swatches
                                swatches-max-height="100"></v-color-picker>
                        </v-col>
                        <v-col cols="6">
                            <v-color-picker v-model="gradientEnd" :mode="mode" label="End Color" show-swatches
                                swatches-max-height="100"></v-color-picker>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" text @click="confirm">确定</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>
</template>
<script>
import { clone } from 'lodash-es'
export default {
    name: 'ColorPicker',
    props: {
        value: { type: String },//默认只接受hexa/hex值
        mode: { type: String, default: 'hexa' },
    },
    components: {},
    data() {
        return {
            dialog: false,
            color: {},
            isGradient: false,
            gradientStart: null,
            gradientEnd: null
        }
    },
    mounted() {
        // this.$set(this.color, this.mode, clone(this.value))//此时value是undefined
        this.color.mode = clone(this.value) || '';
    },
    computed: {

    },
    watch: {
        value(val, ov) {
            // this.$set(this.color, this.mode, clone(val))
            this.color.mode = clone(val) || '';
        }
    },
    methods: {
        confirm() {
            let val = this.color[this.mode]
            // if (this.isGradient) {
            //     val += ` linear-gradient(${this.gradientStart[this.mode]}, ${this.gradientEnd[this.mode]})`
            // }
            console.debug('confirming', val)
            this.$emit('input', val)
            this.dialog = false
        }
    }
}
</script>

<style lang="css" scoped></style>
